export default "__VITE_ASSET__DECNnkcr__"